// Render fragment for HealthcareService — the entity's GraphQL display contract.
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a HealthcareService view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...HealthcareServiceRender }`, [HealthcareServiceRenderFragment]).
 */
export const HealthcareServiceRenderFragment = graphql(`
  fragment HealthcareServiceRender on HealthcareService @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    active
    name
    comment
    type {
      text
      coding {
        system
        code
        display
      }
    }
    extension {
      url
      extension {
        url
        valueInteger
        valuePositiveInt
      }
    }
  }
`);
